<template>
  <BaseModal
    :id="id"
    :close-on-backdrop-click="false"
    :is-directional="true"
    :is-wide="false"
    :on-confirm="onContinueEditing"
    :on-cancel="goToHome"
    :heading="null"
    :confirm-text="$t('Continue Editing')"
    :cancel-text="$t('Studio Home')"
    :disable-confirm-button="busy"
    :disable-cancel-button="busy"
  >
    {{ $t('Your editing session has expired.') }}
    {{ $t("If you wish to resume, please click 'Continue Editing'") }}
  </BaseModal>
</template>
<script>
import { mapActions } from 'pinia';
import BaseModal from '@/components/modals/BaseModal.vue';
import * as types from '@/lib/constants/store';
import {
  useErrorStore,
  useInactivityStore,
  useModalStore,
} from '@/stores';

export default {
  components: {
    BaseModal,
  },
  props: {
    id: {
      type: String, // used for opening and closing modal
      required: true,
    },
    options: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  data() {
    return {
      busy: false,
    };
  },
  methods: {
    ...mapActions(useModalStore, [
      types.CLEAR_MODALS,
    ]),
    ...mapActions(useErrorStore, [
      types.SET_ERROR,
    ]),
    ...mapActions(useInactivityStore, [
      types.CHECK_AUTH_STATUS,
    ]),
    async checkAuth(callback, returnUrl) {
      try {
        this.busy = true;
        await this[types.CHECK_AUTH_STATUS]({ returnUrl });
        callback();
      } catch (error) {
        window.location.href = error.redirectUrl;
      } finally {
        this.busy = false;
      }
    },
    goToHome() {
      this.checkAuth(() => {
        this[types.CLEAR_MODALS]();
        this.$router.push({ name: 'home' });
      }, window.location.origin);
    },
    onContinueEditing() {
      this.checkAuth(() => {
        this[types.SET_ERROR](null);
        this[types.CLEAR_MODALS]();
        this.options.onContinueEditing();
      });
    },
  },
};
</script>
